import { faCircleNotch, faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TheatersRounded } from "@material-ui/icons"
import Breadcrumb from "components/Common/Breadcrumb2"
import toast from "components/Toast/Toast"
import { formatDate } from "helpers"
import { last, upperCase } from "lodash"
import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import { withTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import {
  Alert,
  Card,
  CardBody,
  CardHeader,
  CardText,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import { getOrder } from "services/orders/calls"
import { getOpened, openSupport } from "services/support/calls"
import DetalhesAtendimento from "./DetalhesAtendimento"

const Atendimento = props => {
  document.title = "Atendimento | Sensetek"
  const searchInputRef = useRef()
  const [isLoading, handleLoading] = useState(true)
  const [hasError, setError] = useState(false)
  const [orders, setOrders] = useState([])
  const [statuses, setStatuses] = useState([])
  const history = useHistory()
  const location = useLocation()

  // const [showAlert, setShowAlert] = useState(false)

  const checkTrackEvent = () => {
    const queryParams = new URLSearchParams(location.search)
    const rastreio = queryParams.get("rastreio")
    const pedido = queryParams.get("order")
    const q = queryParams.get("q")
    return { rastreio, pedido, q }
  }

  const getURLParams = () => {
    const queryParams = new URLSearchParams(location.search)
    const q = queryParams.get("q")
    return q
  }

  const onSearchTrack = async query => {
    setError(false)
    handleLoading(true)
    try {
      const { payload } = await getOrder(query)
      const { orders, statuses } = payload
      setStatuses(statuses)
      setOrders(orders)
      if (orders.length > 0) {
        const resp = await openSupport(query)
        const { support } = resp.payload
        history.push({
          pathname: `${location.pathname}${support.uuid}`,
          search: `?q=${query}`,
        })
      }
      handleLoading(false)
    } catch (error) {
      handleLoading(false)
      setError(error)
    }
  }

  useEffect(() => {
    const getRequestedOrder = async e => {
      try {
        const { payload } = await getOrder(e)
        const { orders, statuses } = payload
        setStatuses(statuses)
        setOrders(orders)
      } catch (error) {
        setError(error)
      } finally {
        handleLoading(false)
      }
    }
    const query = getURLParams()
    if (query) {
      getRequestedOrder(query)
    } else {
      handleLoading(false)
    }
    // checkOpened()
  }, [])

  const onSearch = async e => {
    e.preventDefault()
    const query = searchInputRef.current.value
    setError(false)
    handleLoading(true)
    try {
      const { payload } = await getOrder(query)
      const { orders } = payload
      if (orders.length > 0) {
        const { payload: sup } = await openSupport(query)
        const { support } = sup
        history.push({
          pathname: `${location.pathname}/${support.uuid}`,
          search: `?q=${query}`,
        })
      }
    } catch (error) {
      toast("warning", "Produto não encontrado!", "Aviso")
      setError(error)
    } finally {
      handleLoading(false)
    }
    // getOrder(query)
    //   .then(async response => {
    //     const { orders, statuses } = response.payload
    //     setStatuses(statuses)
    //     setOrders(orders)
    //     if (orders.length > 0) {
    //       const resp = await openSupport(query)
    //       const { support } = resp.payload
    //       history.push({
    //         pathname: `${location.pathname}/${support.uuid}`,
    //         search: `?q=${query}`,
    //       })
    //     }
    //     handleLoading(false)
    //   })
    //   .catch(err => {
    //     toast("warning", "Produto não encontrado!", "Aviso")
    //     handleLoading(false)
    //     setError(err)
    //   })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Atendimento")}
            breadcrumbItems={[
              { title: props.t("Consulta de Pedidos"), path: "#" },
            ]}
          />
          <Row>
            <Col>
              <Card>
                <CardHeader className="text-center">
                  <b>{upperCase(props.t("Consulta de Pedidos"))}</b>
                </CardHeader>
                <CardBody>
                  {/* {orders.length === 0 && (
                    <Form
                      onSubmit={e => {
                        onSearch(e)
                      }}
                    >
                      <InputGroup>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Buscar por pedido"
                          ref={searchInputRef}
                          disabled={isLoading}
                          onChange={e => {
                            searchInputRef.current.value = e.target.value
                          }}
                        />
                        <div
                          className="input-group-append"
                          style={{
                            position: "absolute",
                            right: 10,
                            top: 8,
                            zIndex: 100,
                          }}
                        >
                          <div role="button" onClick={onSearch}>
                            <i className="bx bx-search-alt"></i>
                          </div>
                        </div>
                      </InputGroup>
                    </Form>
                  )} */}
                  {orders.length > 0 && (
                    <div>
                      <Nav tabs>
                        {orders.reverse().map((order, index) => (
                          <NavItem key={index}>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className="active"
                            >
                              {`Emissão ${formatDate(
                                order.emittedAt ||
                                  order.orderedAt ||
                                  order.createdAt
                              )}`}
                            </NavLink>
                          </NavItem>
                        ))}
                      </Nav>
                      <TabContent activeTab={"1"} className="text-muted">
                        {orders.reverse().map((order, index) => (
                          <TabPane tabId="1" key={index}>
                            <Row>
                              <Col sm="12">
                                <DetalhesAtendimento
                                  orderIndex={index}
                                  order={order}
                                  statuses={statuses}
                                  onFinished={() => {
                                    setOrders([])
                                  }}
                                  // showAlert={showAlert}
                                  // setShowAlert={setShowAlert}
                                ></DetalhesAtendimento>
                              </Col>
                            </Row>
                          </TabPane>
                        ))}
                      </TabContent>
                    </div>
                  )}
                  {isLoading && (
                    <div
                      style={{
                        paddingTop: 20,
                        paddingBottom: 20,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faCircleNotch}
                        spin
                        size="2x"
                        color="#000"
                      />
                    </div>
                  )}
                  {!isLoading && orders.length === 0 && (
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        width: "100%",
                        height: 500,
                        background: "rgba(0,0,0,0.1)",
                      }}
                    >
                      <div className="text-center">
                        <FontAwesomeIcon
                          icon={faSearch}
                          color="rgba(0,0,0,0.1)"
                          size="10x"
                        />
                        <p className="text-center mt-4">
                          Inicie o atendimento buscando pela Chave do produto
                        </p>
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Atendimento.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Atendimento)
